import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as jobActions, operations as jobOperations } from '@saucelabs/sl-module-jobs';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { utils as authUtils } from '@saucelabs/sl-container-authentication';
import { actions as performanceActions } from '@saucelabs/sl-module-performance';
import { parse } from 'qs';
import { push } from 'connected-react-router';
import { actions as buildsActions } from '@saucelabs/sl-module-builds';

import { actions as historyActions } from '../performanceHistory';
import { INITIALIZE } from './types';
import * as actions from './actions';
import { PERFORMANCE_EVENTS, trackEvent } from './../../tracking';
import { actions as buildsV2Actions } from './../build';

import { operations } from './index';

export const getBuild = (job) => async (dispatch) => {
  if (!job.getBuildName()) {
    return Promise.resolve();
  }

  return dispatch(buildsV2Actions.getBuildByJobId({ id: job.get('id') }, { skipErrorPage: true }));
};

export const tryGetBuildByName = (job) => (dispatch) => {
  const buildName = job.getBuildName();
  if (!buildName) {
    return Promise.resolve();
  }

  return dispatch(buildsActions.getBuildByName({
    buildName,
    username: job.get('owner'),
  }, { skipErrorPage: true }));
};

export const initialize = createApiAction(
  INITIALIZE,
  (payload, meta, dispatch, getState) => Promise.all([
    dispatch(jobOperations.fetchJob(payload)),
    dispatch(trackEvent(PERFORMANCE_EVENTS.PERFORMANCE_REPORT_OPEN)),
  ]).then(() => {
    const state = getState();
    const job = state.apps.extendedDebugging.container.get('job');
    const isAuthenticatedUser = state.user.isAuthenticated();
    const isPublicJob = job.isPublic();
    const routerLocation = state.router.location;
    const currentPathname = routerLocation.pathname;
    const qs = parse(routerLocation.search, { ignoreQueryPrefix: true });
    const authInQS = !!qs.auth;
    const isPerformanceEnabled = state.apps.extendedDebugging.container.getIn(['job', 'performance_enabled']);

    if (!isPerformanceEnabled) {
      return Promise.all([
        dispatch(operations.cleanup()),
        dispatch(push({ pathname: `/tests/${payload.id}` })),
      ]);
    }

    if ((!isAuthenticatedUser && !authInQS) && !isPublicJob) {
      throw authUtils.redirectToMainLogin(currentPathname);
    }

    return dispatch(operations.getBuild(job));
  }),
);

export const onRouteParamsChange = ({
  prevValue, jobId, pageIndex, auth,
}) => (dispatch) => Promise.all([
  dispatch(actions.updatePageIndex(pageIndex)),
  (prevValue.jobId !== jobId ?
    dispatch(operations.initialize({
      id: jobId,
      auth,
      config: {
        params: { full: true, auth },
      },
    }, { skipErrorPage: true })) :
    dispatch(actions.updateShouldCallInit(false))
  ),
]);

export const changeJobVisibility = ({ id, visibility, username }) => (dispatch) => (
  dispatch(jobActions.changeVisibility({ id, visibility, username }))
    .then(() => dispatch(notificationActions.notifySuccess('Visibility changed')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to change job visibility',
    )))
);

export const cleanup = () => (dispatch) => (
  Promise.all([
    dispatch(performanceActions.cleanup()),
    dispatch(historyActions.cleanup()),
  ])
);
